const authRoles = {
    ADMIN: 'SCE_ADMIN',
    USER: 'SCE_USER',
}

export default authRoles
